import { useVirtualizer } from "@tanstack/react-virtual";
import { CSRDQuestion } from "./index";
import * as React from "react";
import { Box } from "@chakra-ui/react";

function QuestionsVirtualizedList({
                                    items,
                                    questionnaireYear,
                                    comments,
                                    assignee,
                                    register,
                                    control,
                                    setValue,
                                    isPreview
                                  }) {
  const parentRef = React.useRef(null);

  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => document.body.scrollHeight - 340,
    enabled: true
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <>
      <Box
        ref={parentRef}
        style={{
          height: document.body.scrollHeight - 320,
          overflowY: "auto",
          contain: "strict"
        }}
      >
        <Box
          style={{
            height: virtualizer.getTotalSize(),
            width: "100%",
            position: "relative"
          }}
        >
          <Box
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              transform: `translateY(${virtualItems[0]?.start ?? 0}px)`,
              paddingInlineStart: "5px",
              paddingInlineEnd: "10px"
            }}
          >
            {virtualItems.map((virtualRow) => {
              return (
                <Box
                  key={virtualRow.key}
                  data-index={virtualRow.index}
                  ref={virtualizer.measureElement}
                >
                  <CSRDQuestion
                    questionEl={items[virtualRow.index]}
                    questionElIndex={virtualRow.index}
                    questionnaireYear={questionnaireYear}
                    register={register}
                    control={control}
                    setValue={setValue}
                    isPreview={isPreview}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default QuestionsVirtualizedList;